import React from "react";
import "./navbar.css";
import { Link, NavLink  , useLocation} from "react-router-dom";
export default function Navbar() {
  const location = useLocation();

  return (
    <div>
      <div className="topnav">
        <div className="logo">
          <span>root@home:~{location.pathname}</span>
        </div>

        <div className="navbar">
          {/* button go click to open site */}

          <NavLink to="/"  >Home</NavLink>
          
          <NavLink to="/challenges">Past CTFs</NavLink>
          <NavLink to="/about">About</NavLink>
          <a className="custom-btn btn-1" href="https://apoorvctf.iiitkottayam.ac.in/" style={{color : "var(--color-6)", fontSize : "1.3rem" , padding : "2px 12px" , marginLeft : "20px" }}>Register</a>

        </div>
        <div className="a-cont">
        {/* <a className="custom-btn btn-1" href="https://apoorvctf.iiitkottayam.ac.in/" style={{color : "var(--color-6)", fontSize : "1.3rem" , padding : "2px 12px" }}>Register</a> */}
        </div>
      </div>
    </div>
  );
}
